import React from 'react'
import SvgIcon from './SvgIcon'

export default function HideIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 15 8">
      <path d="M0.661668 0.59181C1.02713 0.264971 1.61966 0.264971 1.98512 0.59181L7.30112 5.34602L12.6171 0.591809C12.9826 0.26497 13.5751 0.26497 13.9406 0.591809C14.306 0.918648 14.306 1.44856 13.9406 1.7754L7.98505 7.10155C7.61959 7.42839 6.98265 7.42839 6.61719 7.10155L0.661668 1.7754C0.296208 1.44856 0.296208 0.918649 0.661668 0.59181Z"/>
    </SvgIcon>
  )
}

HideIcon.displayName = 'HideIcon'
